import React from 'react';
import { InfoCircleFill } from '@icons';

const Banner = ({ variant, message, hasIcon = true, otherElement = null, ...props }) => {
	let icon = null;
	let backgroundColor = null;
	let color = null;

	switch (variant) {
		case 'success':
			//wip
			break;
		case 'danger':
			//wip
			backgroundColor = 'var(--np-light-red)';
			color = 'var(--np-red)';
			icon = (
				<InfoCircleFill
					aria-label="Errore"
					style={{
						fill: 'var(--np-red)',
					}}
				/>
			);

			break;
		case 'info':
			//wip
			backgroundColor = '#edf0f7';
			break;
		case 'warning':
			backgroundColor = 'var(--np-light-orange)';
			color = 'var(--np-orange)';
			icon = (
				<InfoCircleFill
					aria-label="Avviso"
					style={{
						fill: 'var(--np-orange)',
					}}
				/>
			);

			break;
		case 'blank':
			backgroundColor = 'white';
			color = 'var(--np-text-primary-color)';
			break;
		default:
			break;
	}

	return (
		<div
			{...props}
			style={{
				...props.style,
				backgroundColor: backgroundColor,
				color: color,
				borderRadius: '10px',
				alignItems: 'center',
				padding: '20px',
				fontSize: '16px',
				margin: 'auto',
				display: 'flex',
				gap: '.75rem',
				justifyContent: 'flex-start',
			}}
		>
			{hasIcon ? <div style={{ flexShrink: 0, display: 'flex' }}>{icon}</div> : null}

			<div>{message}</div>

			{otherElement ? <div className="ms-auto">{otherElement}</div> : null}
		</div>
	);
};
export default Banner;
